import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { boostrapColourToHex } from '../utils';

const TrappingZoneStatusModal = ({ children, title, body }) => {
  const [show, setShow] = useState(false);

  const hide = () => {
    setShow(false);
  };

  return (
    <Fragment>
      <div className='d-inline' onClick={() => setShow(true)}>
        {children}
      </div>
      <Modal show={show} onHide={() => hide()}>
        <Modal.Header
          style={{ backgroundColor: boostrapColourToHex['secondary'] }}
        >
          <Modal.Title>
            <h5 className='text-light mb-0'>{title}</h5>
          </Modal.Title>
          <Button
            type='button'
            variant='link'
            className='text-light p-0 m-0 mr-1'
            onClick={() => hide()}
          >
            <FontAwesomeIcon icon={faTimes} size='lg' />
          </Button>
        </Modal.Header>
        <Modal.Body>{body}</Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default TrappingZoneStatusModal;
